module.exports = __webpack_public_path__ + "public/img/logo_login-hgd.7c304aee.png";